import React from 'react'
import { Card, Grid } from '@softwaredev_cegeka/stix-core'
import { CustomIcon } from 'src/components/CustomIcon'
import './unauthorizedCard.scss'

class UnauthorizedCard extends React.Component {
    render() {
        return (
            <Grid.Row>
                <Grid.Col md={{ offset: 4, span: 4 }}>
                    <Card className={'unauthorized-card'}>
                        <Card.Body>
                            <CustomIcon icon={'unauthorized'} />
                            <div className={'unauthorized-content'}>
                                <Card.Title className={'unauthorized-title'}>
                                    Unauthorized
                                </Card.Title>
                                <p>
                                    You are not authorized to access this data.
                                </p>
                            </div>
                        </Card.Body>
                    </Card>
                </Grid.Col>
            </Grid.Row>
        )
    }
}

export default UnauthorizedCard
